import React from 'react';
import { Box } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import {
  FiActivity,
  FiCpu,
  FiDatabase,
  FiDownload,
  FiEdit2,
  FiGrid,
  FiLayers,
  FiLogOut,
  FiMenu,
  FiPlus,
  FiRefreshCcw,
  FiTrash2,
  FiUploadCloud,
  FiUsers,
  FiCheckCircle,
  FiInfo,
  FiAlertTriangle,
  FiBox,
  FiX,
  FiShoppingCart,
} from 'react-icons/fi';
import { MdOutlineInventory } from 'react-icons/md';

// Re-export icons as components that work with React 19
// This wrapper fixes the JSX compatibility issue with react-icons

interface IconProps {
  size?: number | string;
  color?: string;
}

const createIcon = (Icon: IconType): React.FC<IconProps> => {
  const WrappedIcon: React.FC<IconProps> = ({ size = '1em', color }) => {
    return <Box as={Icon as React.ElementType} fontSize={size} color={color} display="inline-block" verticalAlign="middle" />;
  };
  return WrappedIcon;
};

// Feather Icons
export const ActivityIcon = createIcon(FiActivity);
export const CpuIcon = createIcon(FiCpu);
export const DatabaseIcon = createIcon(FiDatabase);
export const DownloadIcon = createIcon(FiDownload);
export const EditIcon = createIcon(FiEdit2);
export const GridIcon = createIcon(FiGrid);
export const LayersIcon = createIcon(FiLayers);
export const LogOutIcon = createIcon(FiLogOut);
export const PlusIcon = createIcon(FiPlus);
export const RefreshIcon = createIcon(FiRefreshCcw);
export const TrashIcon = createIcon(FiTrash2);
export const UploadCloudIcon = createIcon(FiUploadCloud);
export const UsersIcon = createIcon(FiUsers);
export const CheckCircleIcon = createIcon(FiCheckCircle);
export const InfoIcon = createIcon(FiInfo);
export const AlertTriangleIcon = createIcon(FiAlertTriangle);
export const BoxIcon = createIcon(FiBox);
export const MenuIcon = createIcon(FiMenu);
export const CloseIcon = createIcon(FiX);
export const ShoppingCartIcon = createIcon(FiShoppingCart);

// Material Icons
export const InventoryIcon = createIcon(MdOutlineInventory);

// IconType alias for compatibility
export type { IconType };

// Helper for creating nav items
export const iconMap = {
  activity: ActivityIcon,
  cpu: CpuIcon,
  database: DatabaseIcon,
  download: DownloadIcon,
  edit: EditIcon,
  grid: GridIcon,
  layers: LayersIcon,
  logout: LogOutIcon,
  menu: MenuIcon,
  close: CloseIcon,
  plus: PlusIcon,
  refresh: RefreshIcon,
  trash: TrashIcon,
  uploadCloud: UploadCloudIcon,
  users: UsersIcon,
  inventory: InventoryIcon,
  checkCircle: CheckCircleIcon,
  info: InfoIcon,
  alertTriangle: AlertTriangleIcon,
  box: BoxIcon,
};
